var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contactList"}},[_c('ul',_vm._l((_vm.lists),function(list){return _c('contactItem',{key:list.id,attrs:{"list":list},on:{"info-contact":_vm.onInfo,"del":_vm.delit}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }